import { format } from "date-fns";
import { cn } from "@/lib/utils";

interface DayButtonProps {
  day: Date;
  className?: string;
  disabled: boolean;
  onClick: () => void;
}

export const DayButton = (props: Readonly<DayButtonProps>) => {
  const { day, className, disabled, onClick } = props;

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={cn(
        "w-8 h-8 flex items-center justify-center text-[14px] font-medium transition-colors rounded-full",
        className,
      )}
    >
      {format(day, "d")}
    </button>
  );
};
